import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import ApproverNameField from "features/activity/components/ApproverNameField/ApproverNameField";

const ApproverNameDialog = ({ open, onConfirm, onCancel, value, onChange, clientAccountId }) => (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
        <DialogTitle>Approver Name Required</DialogTitle>
        <DialogContent>
            <ApproverNameField value={value} onChange={onChange} clientAccountId={clientAccountId} />
        </DialogContent>
        <DialogActions>
            <Button onClick={onCancel} color="primary">Cancel</Button>
            <Button onClick={onConfirm} color="primary" variant="contained" disabled={!value?.trim()}>Confirm</Button>
        </DialogActions>
    </Dialog>
);

export default ApproverNameDialog;
